export default [
  {
    value: 'created',
    label: 'Solicitada'
  },
  {
    value: 'processing',
    label: 'Processando'
  },
  {
    value: 'processed',
    label: 'Concluída'
  }
]
